interface ParseIntOrDefault {
  (value?: unknown, defaultValue?: number): number
}

const parseIntOrDefault: ParseIntOrDefault = (value, defaultValue = NaN) => {
  const parsedValue = parseInt(value as string)
  return isNaN(parsedValue) ? defaultValue : parsedValue
}

export default parseIntOrDefault
